export const appPageMetaData = {
    fullWidth: true
}
